import axios from 'axios';
import axiosRetry from 'axios-retry';

import config from '../config';
import { authClient } from '../auth';

const {
  network: { apiKey, apiBaseUrl },
} = config;

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'X-API-Key': apiKey,
  },
});

export const useInterceptors = (getTokens, setTokens) => {
  apiClient.interceptors.request.use((config) => {
    config.headers['Authorization'] = `Bearer ${getTokens().accessToken}`;
    return config;
  });

  axiosRetry(apiClient, {
    retries: 1,
    retryCondition: (error) => error.response?.status === 401,
    onRetry: async (count, error, request) => {
      const data = await authClient.signinSilent(getTokens().refreshToken);
      setTokens({
        accessToken: data.access_token,
        idToken: data.id_token,
        refreshToken: data.refresh_token,
      });
      request.headers['Authorization'] = `Bearer ${data.access_token}`;
    },
  });
};

export default apiClient;
